import { render } from "./PriceDisplay.vue?vue&type=template&id=681990c4&scoped=true&ts=true"
import script from "./PriceDisplay.vue?vue&type=script&lang=ts"
export * from "./PriceDisplay.vue?vue&type=script&lang=ts"

import "./PriceDisplay.vue?vue&type=style&index=0&id=681990c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681990c4"]])

export default __exports__